import { Text } from "@chakra-ui/react";
import { Select, SelectButton, SelectList } from "@saas-ui/react";

export const SelectPageSize = ({
  pageSize,
  onPageSizeChange,
}: {
  pageSize: number;
  onPageSizeChange: (page: number) => void;
}) => {
  return (
    <div
      data-cy="page_size-select"
      className="flex justify-start items-center gap-2"
    >
      <Text fontSize="sm">Page size:</Text>
      <Select
        onChange={(value) => onPageSizeChange(parseInt(value, 10))}
        name="page_size"
        value={pageSize.toString()}
        options={[
          { label: "10", value: "10" },
          { label: "25", value: "25" },
          { label: "50", value: "50" },
          { label: "100", value: "100" },
        ]}
      >
        <SelectButton fontSize="sm" />
        <SelectList fontSize="sm" />
      </Select>
    </div>
  );
};
